import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getAPISingleAnswer = (params) => {
	const url = ApiRouters.API_SINGLE_ANSWER;
	return api.get(url, { params });
};

export const postAPISingleAnswer = (body) => {
	const url = ApiRouters.API_SINGLE_ANSWER;
	return api.post(url, body);
};

export const getAPISingleAnswerDetail = (id, params) => {
	const url = `${ApiRouters.API_SINGLE_ANSWER}/${id}`;
	return api.get(url, { params });
};

export const putAPISingleAnswerDetail = (id, body) => {
	const url = `${ApiRouters.API_SINGLE_ANSWER}/${id}`;
	return api.put(url, body);
}

export const deleteAPISingleAnswer = (id) => {
	const url = `${ApiRouters.API_SINGLE_ANSWER}/${id}`;
	return api.delete(url);
};

// export const createQuesReadAloud = (body) => {
// 	const url = ApiRouters.READALOUD;
// 	return api.post(url, body);
// };

// export const updateReadAloudDetail = (body) => {
// 	const url = `${ApiRouters.READALOUD}/${body.id}`;
// 	return api.put(url, body);
// };